module.exports = __webpack_public_path__ + "img/tennis.e638191e.svg";